(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const initializeFooterDisclosures = (root = document) => {
    root.querySelectorAll('[data-footer-disclosure-toggle]').forEach((toggle) => {
      if (toggle.dataset.footerDisclosureReady === 'true') return;

      const disclosure = toggle.closest('.footer-block');
      if (!disclosure) return;

      toggle.dataset.footerDisclosureReady = 'true';
      toggle.addEventListener('click', () => {
        const isOpen = disclosure.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    });
  };

  initializeFooterDisclosures();
  document.addEventListener('shopify:section:load', (event) => initializeFooterDisclosures(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initializeReferenceHeaderMenus(root = document) {
    const desktopMedia = window.matchMedia('(min-width: 990px)');
    const menus = root.querySelectorAll('.reference-header header-menu');

    menus.forEach((menu) => {
      if (menu.dataset.referenceHoverBound === 'true') return;
      menu.dataset.referenceHoverBound = 'true';

      const details = menu.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;

      menu.addEventListener('pointerenter', () => {
        if (!desktopMedia.matches) return;

        document.querySelectorAll('.reference-header header-menu details[open]').forEach((openDetails) => {
          if (openDetails === details) return;
          openDetails.removeAttribute('open');
          openDetails.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('pointerleave', () => {
        if (!desktopMedia.matches) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      });
    });
  }

  initializeReferenceHeaderMenus();
  document.addEventListener('shopify:section:load', (event) => {
    initializeReferenceHeaderMenus(event.target);
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reference-slideshow')) {
    customElements.define(
      'reference-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-slideshow-viewport]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.dots = [...this.querySelectorAll('[data-slide-dot]')];
          this.index = 0;
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
          this.viewport?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
            if (event.key === 'ArrowRight') this.goTo(this.index + 1);
          });
          this.viewport?.addEventListener('scrollend', () => this.syncIndex());
          this.addEventListener('animationend', (event) => this.onProgressComplete(event));
          this.updatePagination(false);
        }

        syncIndex() {
          if (!this.viewport?.clientWidth) return;
          const nextIndex = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
          if (nextIndex === this.index) return;
          this.index = nextIndex;
          this.updatePagination(true);
        }

        goTo(index) {
          if (!this.slides.length) return;
          this.index = (index + this.slides.length) % this.slides.length;
          this.viewport.scrollTo({ left: this.index * this.viewport.clientWidth, behavior: 'smooth' });
          this.updatePagination(true);
        }

        updatePagination(restart) {
          const activeSlide = this.slides[this.index];
          if (activeSlide?.dataset.mobileAspectRatio) {
            this.style.setProperty('--reference-slide-mobile-ratio', activeSlide.dataset.mobileAspectRatio);
          }

          this.dots.forEach((dot, index) => {
            const isCurrent = index === this.index;
            if (isCurrent && restart) {
              dot.removeAttribute('aria-current');
              void dot.offsetWidth;
            }
            if (isCurrent) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
        }

        onProgressComplete(event) {
          if (
            event.animationName !== 'reference-slide-progress' ||
            !event.target.matches('[data-slide-progress]') ||
            !event.target.closest('[data-slide-dot]')?.matches('[aria-current="true"]') ||
            this.dataset.autoplay !== 'true' ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches
          )
            return;
          this.goTo(this.index + 1);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const formatReferenceProductMoney = (cents, currency) => {
    const numericCents = Number(cents || 0);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || window.Shopify?.currency?.active || 'USD',
      }).format(numericCents / 100);
    } catch {
      return `$${(numericCents / 100).toFixed(2)}`;
    }
  };

  const initReferenceFbt = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const discount = Number(root.dataset.discount || 0);
    const currency = root.dataset.currency || window.Shopify?.currency?.active || 'USD';
    const sectionId = root.dataset.sectionId;
    const currentLine = root.querySelector('[data-fbt-current-line]');
    const currentVisual = root.querySelector('[data-current-visual]');
    const currentThumbImage = root.querySelector('[data-current-thumb] img');
    const visualItems = Array.from(root.querySelectorAll('[data-fbt-visual-item]'));
    const addButton = root.querySelector('[data-fbt-add]');
    const variantInput = document.querySelector(`#ProductInfo-${sectionId} .product-variant-id`);
    const variantsScript = root.querySelector('[data-reference-fbt-current-variants]');
    let currentVariants = [];

    try {
      currentVariants = JSON.parse(variantsScript?.textContent || '[]');
    } catch {
      currentVariants = [];
    }

    const getCheckedLines = () =>
      Array.from(root.querySelectorAll('[data-fbt-line]')).filter((line) => {
        const checkbox = line.querySelector('[data-fbt-checkbox]');
        return checkbox?.checked;
      });

    const syncVisuals = (checkedLines) => {
      const checkedVariantIds = checkedLines.map((line) => line.dataset.variantId);
      let visibleIndex = 0;

      visualItems.forEach((item) => {
        const isVisible = checkedVariantIds.includes(item.dataset.variantId);
        item.hidden = !isVisible;

        const plus = item.querySelector('[data-fbt-visual-plus]');
        if (plus) {
          plus.hidden = !isVisible || visibleIndex === 0;
        }

        if (isVisible) visibleIndex += 1;
      });
    };

    const updateTotals = () => {
      const checkedLines = getCheckedLines();
      const subtotal = checkedLines.reduce((sum, line) => sum + Number(line.dataset.price || 0), 0);
      const shouldDiscount = checkedLines.length >= 2 && discount > 0;
      const total = shouldDiscount ? Math.round((subtotal * (100 - discount)) / 100) : subtotal;
      const totalNode = root.querySelector('[data-fbt-total]');
      const totalLabel = root.querySelector('[data-fbt-total-label]');

      if (totalNode) totalNode.textContent = formatReferenceProductMoney(total, currency);
      if (totalLabel) {
        totalLabel.textContent = shouldDiscount ? root.dataset.discountTotalLabel : root.dataset.totalLabel;
      }

      if (addButton) {
        addButton.disabled = !checkedLines.length || addButton.dataset.loading === 'true';
      }

      syncVisuals(checkedLines);
    };

    const syncCurrentVariant = () => {
      if (!currentLine || !variantInput) {
        updateTotals();
        return;
      }

      const selectedVariantId = Number(variantInput.value || currentLine.dataset.variantId);
      const selectedVariant = currentVariants.find((variant) => Number(variant.id) === selectedVariantId);
      if (!selectedVariant) {
        updateTotals();
        return;
      }

      currentLine.dataset.variantId = String(selectedVariant.id);
      currentLine.dataset.price = String(selectedVariant.price || 0);
      if (currentVisual) currentVisual.dataset.variantId = String(selectedVariant.id);
      const priceNode = currentLine.querySelector('[data-fbt-line-price]');
      if (priceNode) priceNode.textContent = formatReferenceProductMoney(selectedVariant.price, currency);

      const nextImage = selectedVariant.featured_image?.src || selectedVariant.featured_media?.preview_image?.src;
      if (currentThumbImage && nextImage) {
        currentThumbImage.src = nextImage;
        currentThumbImage.srcset = '';
      }

      updateTotals();
    };

    root.addEventListener('change', updateTotals);

    if (variantInput) {
      variantInput.addEventListener('change', syncCurrentVariant);
      new MutationObserver(syncCurrentVariant).observe(variantInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    }

    addButton?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const checkedLines = getCheckedLines();
      if (!checkedLines.length) return;

      button.dataset.loading = 'true';
      button.disabled = true;

      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const items = checkedLines.map((line) => ({
          id: Number(line.dataset.variantId),
          quantity: 1,
          properties: {
            _fbt: 'true',
            _fbt_discount_percentage: String(discount),
          },
        }));

        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) throw new Error('Cart add failed');
        window.location.href = `${rootPath}cart`;
      } catch {
        button.dataset.loading = 'false';
        button.disabled = false;
        updateTotals();
      }
    });

    syncCurrentVariant();
  };

  document.querySelectorAll('[data-reference-fbt]').forEach(initReferenceFbt);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-promo-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const moveProductPromoBanners = () => {
      const target = document.querySelector('[data-product-promo-banners-target]');
      const promoSections = document.querySelectorAll('[data-product-promo-banners-section]');

      promoSections.forEach((promoSection) => {
        if (target) {
          target.append(promoSection);
          promoSection.classList.add('product-promo-banners--in-product-info');
        }

        promoSection.hidden = false;
      });
    };

    moveProductPromoBanners();
    document.addEventListener('shopify:section:load', moveProductPromoBanners);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class extends HTMLElement {
        connectedCallback() {
          this.render();
        }

        async render() {
          try {
            const storageKey = 'buddha-recent-products';
            const currentHandle = this.dataset.productHandle;
            const limit = Number(this.dataset.limit || 4);
            let savedHandles = [];
            try {
              const storedValue = JSON.parse(localStorage.getItem(storageKey) || '[]');
              if (Array.isArray(storedValue)) savedHandles = storedValue;
            } catch {
              savedHandles = [];
            }
            const handlesToRender = savedHandles.filter((handle) => handle !== currentHandle).slice(0, 12);
            const nextHandles = [currentHandle, ...savedHandles.filter((handle) => handle !== currentHandle)].slice(
              0,
              12
            );
            localStorage.setItem(storageKey, JSON.stringify(nextHandles));

            if (!handlesToRender.length) {
              this.hidden = true;
              return;
            }

            const root = window.Shopify?.routes?.root || '/';
            const currency = window.Shopify?.currency?.active || 'USD';
            const saveTemplate = this.dataset.saveTemplate || 'Save [amount]';
            const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency,
            });

            const products = await Promise.all(
              handlesToRender.map(async (handle) => {
                try {
                  const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
                    headers: { Accept: 'application/json' },
                  });
                  if (!response.ok) return null;
                  return response.json();
                } catch {
                  return null;
                }
              })
            );

            const list = this.querySelector('[data-recent-products]');
            products
              .filter(Boolean)
              .slice(0, limit)
              .forEach((product) => {
                const item = document.createElement('li');
                item.className = 'recent-products__item';
                const link = document.createElement('a');
                link.href = `${root}products/${product.handle}`;
                if (product.featured_image) {
                  const imageMask = document.createElement('div');
                  imageMask.className = 'recent-products__image-mask';
                  const image = document.createElement('img');
                  const imageUrl = new URL(product.featured_image, window.location.origin);
                  imageUrl.searchParams.set('width', '600');
                  image.src = imageUrl.href;
                  image.alt = product.title;
                  image.loading = 'lazy';
                  image.width = 600;
                  image.height = 600;
                  imageMask.append(image);
                  link.append(imageMask);
                }
                const title = document.createElement('h3');
                title.textContent = product.title;
                const price = document.createElement('div');
                price.className = 'recent-products__price';
                if (product.compare_at_price && product.compare_at_price > product.price) {
                  const compare = document.createElement('span');
                  compare.className = 'recent-products__compare';
                  compare.textContent = formatter.format(product.compare_at_price / 100);
                  price.append(compare);
                }
                const salePrice = document.createElement('span');
                salePrice.textContent = formatter.format(product.price / 100);
                price.append(salePrice);
                if (product.compare_at_price && product.compare_at_price > product.price) {
                  const savings = document.createElement('span');
                  savings.className = 'recent-products__savings';
                  savings.textContent = saveTemplate.replace(
                    '[amount]',
                    formatter.format((product.compare_at_price - product.price) / 100)
                  );
                  price.append(savings);
                }
                link.append(title, price);
                item.append(link);
                list.append(item);
              });

            this.hidden = !list.children.length;
          } catch {
            this.hidden = true;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
